import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../../config/config';
import Header from '../../common/header'
import Footer from '../../common/footer'
import SvgIcon from '../../common/svg-icon/svg-icon'
import { Breadcrumb } from 'semantic-ui-react'
import './index.scss'
//import { replaceSpaceInName } from '../../../common/helperMethods';

// import SolarTreeComponent from './tree'
import { NodeLinkGraph } from '../../../components/productpage_wip/data-viz/NodeLinkGraph';
import SEO from '../../../components/seo/SEO';

const ValueChainView = () => {
  const [isOpen, setOpenIndex] = useState(null);
  const [IndustriesData, setIndustriesData] = useState([]);
  const [applications, setapplications] = useState([]);
  const [prod_info, setprod_info] = useState([]);
  const [applicationsCount, setapplicationsCount] = useState(0);
  const [default_industry, setdefault_industry] = useState({})

  const toggleAccordion = () => {
    setOpenIndex(!isOpen);
  };

  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'Value Chain ', content: 'Value Chain ', link: false },
  ]

  useEffect(() => {
    /* if (localStorage.getItem('industry_data') != 'undefined' || localStorage.getItem('industry_data') != undefined) {
      let Industrydata = (localStorage.getItem('industry_data') != undefined) ? JSON.parse(localStorage.getItem('industry_data')) : []
      setIndustriesData(Industrydata)
      let industry = 'Solar'
      if(localStorage.industry_name!= undefined ){
        industry = localStorage.industry_name
      }
      let findIndex = Industrydata.findIndex(obj => {
        obj.expanded = true;
        return obj.name == industry
      })

      setdefault_industry(Industrydata[findIndex])
      setTimeout(() => {
        getProduct(Industrydata[findIndex])
        localStorage.removeItem('industry_name')
      }, 1500);
    } */

    axios.get(`${BASE_URL}/api/v2/industries/get`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      if (data.length > 0) {
        let industry = 'ryh4YXLfWP6DX'
        setIndustriesData(data)
        let findIndex = data.findIndex(obj => {
          obj.expanded = true;
          return obj.product.id == industry
        })

        setdefault_industry(data[findIndex])
        localStorage.setItem('industry_data ', JSON.stringify(data));

        setTimeout(() => {
          getProduct(data[findIndex])
          localStorage.removeItem('industry_name')
        }, 1500);
      }
    }).finally(() => {
      //  setLoading(false)
    })


  }, [])

  const getProduct = (item) => {
    if (item.product != undefined && item.product.id != undefined) {


      setapplications([])
      setprod_info([])
      setapplicationsCount(0)

      axios.get(`${BASE_URL}/api/v1/product/${item.product.id}?value_chain=true`, {
        "from": 0,
        "size": 10
      }).then((response) => {
        const { Item } = response.data

        setprod_info(Item)
        setdefault_industry(item)
        axios.get(`${BASE_URL}/api/v1/product/application/${item.product.id}?value_chain=true`, {
          "from": 0,
          "size": 30
        }).then((response) => {
          const { Items, Count } = response.data
          setapplications(Items)
          setapplicationsCount(Count)

        }).finally(() => {
          //  setLoading(false)
        })

      }).finally(() => {
        //  setLoading(false)
      })
    }
  }


  return (
    <>
      <SEO key="value-chain-seo"
        robots="index, follow"
        canonicalUrl="/value-chain"
        alternateLink="/value-chain"
        pageType={'value-chain'}

      />
      <Header />
      <div className='innerpages-wrapper value-chain-bg'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>
        <section className='valuchainpageview'>
          <div className='mappes-container'>
            <div className='innerpages-wrapper-inner'>
              <div className='innerpages-left-section'>
                <div className='left-content-row'>
                  <div className='value-chain-wrapper'>
                    <div className={`accordion-item ${isOpen ? 'open' : ''}`}>
                      <div className="accordion-title" onClick={toggleAccordion}>
                        <SvgIcon name='chevron-right' viewbox="0 0 10 16" />
                        Why Value Chains Matter
                      </div>
                      <div className="accordion-content">
                        <p>
                          Turn Complex Manufacturing Ecosystems into Strategic Intelligence
                        </p>
                        <ol>
                          <li>
                            <h4>End-to-End Ecosystem Visibility: </h4>
                            Understand how materials, technologies, suppliers, customers, and applications connect across global manufacturing ecosystems.
                          </li>
                          <li>
                            <h4>Portfolio and Innovation Opportunity Discovery: </h4>
                            Identify new technologies, product adjacencies, and capability gaps aligned with your strengths.
                          </li>
                          <li>
                            <h4>Smarter Go-to-Market & Competitive Strategy:</h4>
                            Understand where to expand, which markets to prioritize, and how ecosystem dynamics impact your growth decisions.
                          </li>
                          <li>
                            <h4>Centralized Industry Intelligence:</h4>
                            Replace fragmented information with one structured, secure, and continuously evolving knowledge layer across teams.
                          </li>
                          {/* <li>
                            <h4>Enhance Decision Making</h4>
                            Access real-time market insights to inform your strategic choices.
                          </li> */}
                        </ol>
                      </div>
                    </div>
                    <div className='value-chain-filter'>
                      {IndustriesData.length > 0 && IndustriesData.map(slide => (
                        <button onClick={() => getProduct(slide)} className={default_industry.product.id == slide.product.id ? 'active' : ''} > {slide.name}</button>
                      ))}
                    </div>
                    <div className='value-chain-area'>
                      <NodeLinkGraph applications={applications}
                        applicationsCount={applicationsCount}
                        product={prod_info}
                        from={'new'}
                      />

                      {/* <SolarTreeComponent />  */}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default ValueChainView